<style lang="scss" scoped>
.h3 {
    font-size: 1.5rem;
}
p {
    font-size: 1rem;
    font-weight: lighter;
}
</style>

<template>
    <div class="order-form">
        <el-form ref="form" @submit="submit" :loading="loading" :success="success" :error="server_error">
            <div>
                <div class="h3 font-weight-bold mb-16">Conctactgegevens</div>
                <div class="row mb-24">
                    <el-input v-model="data.first_name" class="col-6 mb-24" label="Voornaam" rules="required" />
                    <el-input v-model="data.last_name" class="col-6 mb-24" label="Achternaam" rules="required" />
                    <el-input v-model="data.email" class="col-6 mb-24" type="email" label="E-mailadres" rules="required|email" />
                    <el-input v-model="data.phone" class="col-6 mb-24" label="Telefoonnummer" rules="required" />
                    <el-input v-model="data.company" class="col-12 mb-24" label="Bedrijf" rules="required" />
                </div>
                <div class="h3 font-weight-bold">Extra</div>
                <p class=" mb-24">Wil je nog een opmerking of speciale wens toevoegen aan je bericht?</p>
                <div class="row mb-32">
                    <el-input v-model="data.message" class="col-12 mb-0" type="textarea" label="Bericht" />
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import hasForm from '../mixins/has-form'

export default {
    name: "form.el-partner-form",

    mixins: [hasForm],

    data: () => ({
        data: {
            first_name: '',
            last_name: '',
            company: '',
            email: '',
            phone: '',
            message: ''
        }
    }),

    methods: {
        submit() {
            this.beforeSubmit()
            axios.post(route('create-partner'), this.data)
                .then(response => {
                    this.handleSuccess()
                    Object.keys(this.data).forEach(prop => {
                        this.data[prop] = ''
                    })
                    requestAnimationFrame(() => {
                        this.$refs.form.$refs.observer.reset();
                    });
                })
                .catch(e => this.handleError(e));
        }
    }
}
</script>
